// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"552b352a","623":"e1e0b143"}[chunkId] + ".chunk.js";
};